import axios from 'axios';

export default data =>
  axios
    .create({
      baseURL: `${process.env.REACT_APP_CMS_BASE_URL}/wp-json`,
    })
    .get(`/hcfm/v1/count?form=${data.slug}`);
